const priorityLetter = {
  L: 'Low',
  M: 'Medium',
  H: 'High',
};

export { priorityLetter };
